import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MainContext } from '../context/MainContext';
import Search from './Search';
import logo from '../assests/dwarkaorthologo.png';
// Gift is only used by the commented-out Offers link below; kept imported
// there in a comment rather than removed, so re-enabling it later is a
// one-line uncomment, not a re-import.
import { ShoppingCart, LogIn, LogOut, User } from 'lucide-react';

const Header = () => {
  const navigate = useNavigate();
  const { token, setToken } = useContext(MainContext);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const cartCount = cartItems
    ? Object.values(cartItems).reduce((sum, qty) => sum + (qty > 0 ? qty : 0), 0)
    : 0;

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken("");
    navigate("/");
    window.location.reload();
  };


  return (
    <header className="bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center flex-wrap md:flex-nowrap gap-x-6 gap-y-3">

        {/* Logo */}
        <Link to="/" className="order-1 flex-shrink-0 flex items-center">
          <img src={logo} alt="Dwarka Orthodontics" className="h-10 md:h-12 object-contain" />
        </Link>

        {/* Right: icons — sits next to logo on mobile, moves after search on desktop */}
        <div className="order-2 md:order-3 ml-auto md:ml-0 flex items-center gap-5 text-gray-700 text-sm sm:text-base">
          {/* Offers page is disabled for now — see routes/index.js.
          <Link to="/offers" className="no-underline flex items-center gap-1.5 text-gray-700 hover:text-[#2D3092] transition-colors">
            <Gift size={19} strokeWidth={1.75} /> <span className="hidden sm:inline">Offers</span>
          </Link>
          */}

          <Link to="/cart" className="relative no-underline flex items-center gap-1.5 text-gray-700 hover:text-[#2D3092] transition-colors">
            <ShoppingCart size={19} strokeWidth={1.75} />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-[#2D3092] text-white text-[10px] leading-4 text-center font-semibold">
                {cartCount > 99 ? '99+' : cartCount}
              </span>
            )}
            <span className="hidden sm:inline">Cart</span>
          </Link>

          {!token ? (
            <Link to="/login" className="no-underline flex items-center gap-1.5 text-gray-700 hover:text-[#2D3092] transition-colors">
              <LogIn size={19} strokeWidth={1.75} /> <span className="hidden sm:inline">Login</span>
            </Link>
          ) : (
            <>
              <span className="hidden sm:flex items-center gap-1.5 text-gray-700">
                <User size={19} strokeWidth={1.75} /> <span>Welcome</span>
              </span>
              <button onClick={handleLogout} className="flex items-center gap-1.5 text-red-600 hover:text-red-700 transition-colors bg-transparent border-0 p-0 cursor-pointer">
                <LogOut size={19} strokeWidth={1.75} /> <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          )}
        </div>

        {/* Search — grows to fill the middle on desktop, own row on mobile */}
        {/* {showSearch && ( */}
          <div className="order-3 md:order-2 w-full md:flex-1 md:mx-2">
            <Search />
          </div>
        {/* )} */}
      </div>
    </header>
  );
};

export default Header;
